var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M48 36ZM37.4 15.2 26.2 26.4a6.8 6.8 0 0 1-2.8 1.8 7 7 0 0 1-6.8-1.6L.6 10a3.9 3.9 0 0 0-.6 2v20.2a3.6 3.6 0 0 0 3.6 3.6h35.8a3.6 3.6 0 0 0 3.6-3.6V18.8a10.1 10.1 0 0 1-5.6-3.6Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M35.6 8.4H4.2l15.4 15.4a2.8 2.8 0 0 0 3.8 0l12.2-12.2a8.2 8.2 0 0 1-.2-2.2 1.8 1.8 0 0 1 .2-1Z","key":1}),React.createElement("path",{"fill":"none","d":"M44 0a9.6 9.6 0 0 0-8.6 8.4l-.2 1.2.2 2.2a10.2 10.2 0 0 0 1.8 3.6 9.1 9.1 0 0 0 5.8 3.4l1.6.2A9.4 9.4 0 0 0 54 9.6c.4-5.4-4.6-10-10-9.6Z","key":2}),React.createElement("path",{"fill":"currentColor","d":"M46.8 1.6a7.1 7.1 0 0 0-8.2 8.4 7.3 7.3 0 0 0 5.6 5.6 7.2 7.2 0 0 0 8.4-8.4 7.5 7.5 0 0 0-5.8-5.6Zm3.6 7.8h-4V14h-1.8V9.4h-4V7.6h4V3.4h1.8v4.2h4Z","key":3})]);
}

Mail.defaultProps = {"id":"mail","viewBox":"0 0 54 35.8"};

module.exports = Mail;

Mail.default = Mail;
